import { render, staticRenderFns } from "./PasswordUpdateForm.vue?vue&type=template&id=fc39d5bc&scoped=true"
import script from "./PasswordUpdateForm.vue?vue&type=script&lang=js"
export * from "./PasswordUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc39d5bc",
  null
  
)

export default component.exports